import { render, staticRenderFns } from "./AlcoholScreeningQuestionnaire.vue?vue&type=template&id=0852ff1c"
import script from "./AlcoholScreeningQuestionnaire.vue?vue&type=script&lang=js"
export * from "./AlcoholScreeningQuestionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports